import { Check, X, CircleDot, Activity, MinusCircle } from "lucide-react";

/**
 * HitTrackerBadge — Iter 108
 *
 * Renders a tiny coloured pill on every market chip indicating whether
 * the prediction has hit, missed, voided, is currently live, or is still
 * pending (pre-match).  Backend tags each chip with `tracker` via
 * `prediction_outcomes.annotate_outcomes`.
 *
 * Props
 *   tracker — "hit" | "miss" | "void" | "live" | "pending"
 */
const STYLES = {
  hit: {
    cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
    Icon: Check,
    label: "Hit",
  },
  miss: {
    cls: "bg-rose-500/15 text-rose-400 border-rose-500/40",
    Icon: X,
    label: "Miss",
  },
  void: {
    cls: "bg-muted text-muted-foreground border-border",
    Icon: MinusCircle,
    label: "Void",
  },
  live: {
    cls: "bg-amber-500/15 text-amber-500 border-amber-500/40",
    Icon: Activity,
    label: "Live",
  },
  pending: {
    cls: "bg-muted/60 text-muted-foreground border-border",
    Icon: CircleDot,
    label: "Pending",
  },
};

export const HitTrackerBadge = ({ tracker }) => {
  const meta = STYLES[tracker] || STYLES.pending;
  const { Icon, cls, label } = meta;
  const live = tracker === "live";
  return (
    <span
      data-testid={`hit-tracker-${tracker}`}
      title={
        tracker === "hit"
          ? "Pick correct"
          : tracker === "miss"
          ? "Pick missed"
          : tracker === "void"
          ? "Market voided"
          : tracker === "live"
          ? "Match in progress"
          : "Awaiting kickoff"
      }
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border text-[10px] font-bold tracking-[0.06em] uppercase ${cls}`}
    >
      {live ? (
        <span className="relative flex w-1.5 h-1.5">
          <span className="absolute inline-flex w-full h-full rounded-full bg-amber-400 opacity-75 animate-ping" />
          <span className="relative inline-flex w-1.5 h-1.5 rounded-full bg-amber-400" />
        </span>
      ) : (
        <Icon className="w-2.5 h-2.5" />
      )}
      {label}
    </span>
  );
};

export default HitTrackerBadge;
